import { Component } from '@angular/core';
import { EventsModule } from '../../../../events/events.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-championship-editor-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    EventsModule,
  ],
  templateUrl: './championship-editor-dashboard-page.component.html',
})
export class ChampionshipEditorDashboardPageComponent { }
